var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPage)?_c('Nuxt',{attrs:{"keep-alive":_vm.keepAlive,"keepAliveProps":_vm.keepAliveProps}}):_c('Error',{attrs:{"error":{ statusCode: 401, message: '未登录' }}}),_vm._v(" "),_c('ViewToken'),_vm._v(" "),_c('ViewVersion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }